import React, { useMemo } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { useGetAdditionsQuery } from "AppQuries/payroll/addition/get-all-additions";
import { useGetDeductionsQuery } from "AppQuries/payroll/deduction/get-all-deduction";
import { PlusCircle, Trash2 } from "react-feather";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import Select from "react-select";
const PayrollAdditionDeductionForm = () => {
  const userData = useSelector(loggedInUser);

  const {
    control,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "payrollDetail",
  });

  const companyCode = watch("companyCode");
  const userName = watch("userName");

  // ✅ Queries
  const { data: allowance, isLoading: isAllowanceLoading } =
    useGetAdditionsQuery({ companyCode: userData?.companyCode });

  const { data: deduction, isLoading: isDeductionLoading } =
    useGetDeductionsQuery({ companyCode: userData?.companyCode });

  // ✅ Memoized options
  const additions = useMemo(
    () =>
      allowance?.data?.map((o) => ({
        id: o.code,
        label: o.description,
        value: o.code,
      })) || [],
    [allowance],
  );

  const deductions = useMemo(
    () =>
      deduction?.data?.map((o) => ({
        id: o.code,
        label: o.description,
        value: o.code,
      })) || [],
    [deduction],
  );

  // ✅ Add row
  const handleAdd = (type) => {
    append({
      companyCode,
      refNo: 0,
      slNo: 0,
      adjType: type === "addition" ? 1 : 0,
      adjCode: "",
      adjDescription: "",
      haveCPF: false,
      isTaxPayable: false,
      createUser: userName,
      amount: 0,
    });
  };

  // ✅ Single handler (merged logic)
  const handleSelect = (value, index, type) => {
    console.log(value, index, type);
    const source = type === 1 ? allowance?.data : deduction?.data;
    const selected = source?.find((d) => d.code === value);
    if (!selected) return;

    setValue(`payrollDetail.${index}.adjCode`, selected.code);
    setValue(`payrollDetail.${index}.adjDescription`, selected.description);
    setValue(`payrollDetail.${index}.isTaxPayable`, selected.isTaxPayable);
    setValue(`payrollDetail.${index}.haveCPF`, selected.haveCpf);
  };

  // ✅ Render fields (NO findIndex)
  const renderFields = (type) =>
    fields.map((field, index) => {
      if (field.adjType !== type) return null;

      const isAddition = type === 1;

      return (
        <div className="row" key={field.id}>
          <div className="col-2">
            <button
              type="button"
              className="btn btn-default btn-sm"
              onClick={() => remove(index)}
              style={{ marginTop: "20px" }}
            >
              <Trash2 className="w-4 h-4 text-red-600" />
            </button>
          </div>

          <div className="col-5 form-floating">
            <Controller
              name={`payrollDetail.${index}.year`}
              control={control}
              value={
                isAddition
                  ? additions?.find(
                      (opt) =>
                        opt.value ===
                        getValues(`payrollDetail?.[${index}]?.adjCode`),
                    )
                  : deductions?.find(
                      (opt) =>
                        opt.value ===
                        getValues(`payrollDetail?.[${index}]?.adjCode`),
                    )
              } //}
              render={({ field }) => (
                <Select
                  {...field}
                  // options={options}
                  options={isAddition ? additions : deductions}
                  onChange={(selected) =>
                    handleSelect(selected.value, index, type)
                  }
                  className={`form-control ${
                    errors.payrollDetail?.[index]?.adjCode ? "is-invalid" : ""
                  }`}
                  placeholder={`Select ${isAddition ? "Addition" : "Deduction"}`}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              )}
            />
            {/* <Input
              name={`payrollDetail.${index}.adjCode`}
              type="select"
              className={`form-control ${
                errors.payrollDetail?.[index]?.adjCode ? "is-invalid" : ""
              }`}
              options={isAddition ? additions : deductions}
              placeholder="Select"
              onChange={(selected) => handleSelect(selected.value, index, type)}
            /> */}
          </div>

          <div className="col-5 ">
            <Input
              name={`payrollDetail.${index}.amount`}
              type="text"
              className={`form-control ${
                errors.payrollDetail?.[index]?.amount ? "is-invalid" : ""
              }`}
            />
          </div>
        </div>
      );
    });

  return (
    <div className="row">
      {/* Additions */}
      <div className="col-md-6">
        <div className="d-flex justify-content-between mb-3">
          <h6>Additions</h6>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => handleAdd("addition")}
          >
            <PlusCircle className="me-2" /> Add Allowance
          </button>
        </div>

        {isAllowanceLoading && <p>Loading...</p>}
        {renderFields(1)}
      </div>

      {/* Deductions */}
      <div className="col-md-6">
        <div className="d-flex justify-content-between mb-3">
          <h6>Deductions</h6>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => handleAdd("deduction")}
          >
            <PlusCircle className="me-2" /> Add Deduction
          </button>
        </div>

        {isDeductionLoading && <p>Loading...</p>}
        {renderFields(0)}
      </div>
    </div>
  );
};

export default PayrollAdditionDeductionForm;

// import React, { useEffect } from "react";
// import { useFieldArray, useFormContext } from "react-hook-form";
// import Input from "Components/UI/Input";
// import { useGetAdditionsQuery } from "AppQuries/payroll/addition/get-all-additions";
// import { useGetDeductionsQuery } from "AppQuries/payroll/deduction/get-all-deduction";
// import { PlusCircle, Trash2, X } from "react-feather";
// import { useSelector } from "react-redux";
// import { loggedInUser } from "core/redux/slice/authSlice";
// import { use } from "react";
// import { Button, Select } from "antd";
// import { Trash } from "feather-icons-react/build/IconComponents";
// const PayrollAdditionDeductionForm = () => {
//   const userData = useSelector(loggedInUser);

//   const {
//     control,
//     register,
//     watch,
//     setValue,
//     formState: { errors },
//   } = useFormContext();

//   const { fields, append, remove } = useFieldArray({
//     control,
//     name: "payrollDetail",
//   });

//   const handleAdd = (type) => {
//     const newEntry = {
//       companyCode: watch("companyCode"),
//       refNo: 0,
//       slNo: 0,
//       adjType: type === "addition" ? 1 : 0,
//       adjCode: "",
//       adjDescription: "",
//       haveCPF: false,
//       isTaxPayable: false,
//       createUser: watch("userName"),
//       amount: 0,
//     };

//     append(newEntry);
//   };

//   const filteredFields = (type) =>
//     fields.filter((item) => item.adjType === type);

//   const renderFields = (type) =>
//     filteredFields(type).map((field, index) => {
//       // Get the actual index in fields[] to remove correctly
//       const actualIndex = fields.findIndex((f) => f.id === field.id);
//       const isAddition = field.adjType === 1;

//       return (
//         <div className="row" key={field.id}>
//           <div className="col-2">
//             <button
//               type="button"
//               className="btn btn-default btn-sm"
//               onClick={() => remove(actualIndex)}
//               style={{ marginTop: "20px" }}
//             >
//               <Trash2 className="w-4 h-4 text-red-600" />
//             </button>
//           </div>
//           <div className="col-5 form-floating">
//             <Input
//               name={`payrollDetail[${actualIndex}].adjCode`}
//               type="commonSelect"
//               className={`form-control ${
//                 errors.payrollDetail?.[actualIndex]?.adjDescription
//                   ? "is-invalid"
//                   : ""
//               }`}
//               options={isAddition ? additions : deductions}
//               placeholder="Select Deduction"
//               onSelect={(e) =>
//                 isAddition
//                   ? selectAllowanceHandler(e, actualIndex)
//                   : selectDeductionHandler(e, actualIndex)
//               }
//               defaultValue={
//                 watch(`payrollDetail[${actualIndex}].adjCode`) || ""
//               }
//             />
//           </div>
//           <div className="col-5 form-floating">
//             <Input
//               name={`payrollDetail[${actualIndex}].amount`}
//               label=""
//               className={`form-control ${
//                 errors.payrollDetail?.[actualIndex]?.amount ? "is-invalid" : ""
//               }`}
//               placeholder=""
//               type="text"
//               required={false}
//               labelClassName=""
//               requiredMessage="This field is required"
//               defaultValue={watch(`payrollDetail[${actualIndex}].amount`) || 0}
//             />
//           </div>
//         </div>
//       );
//     });

//   const {
//     data: allowance,
//     isLoading: isAllowanceLoading,
//     isError: isAllowanceError,
//   } = useGetAdditionsQuery({ companyCode: userData?.companyCode });
//   const {
//     data: deduction,
//     isLoading: isDeductionLoading,
//     isError: isDeductionError,
//   } = useGetDeductionsQuery({ companyCode: userData?.companyCode });

//   const additions = Array.isArray(allowance?.data)
//     ? allowance.data.map((o) => ({
//         id: o.code,
//         label: o.description,
//         value: o.code,
//       }))
//     : [];

//   const deductions = Array.isArray(deduction?.data)
//     ? deduction.data.map((o) => ({
//         id: o.code,
//         label: o.description,
//         value: o.code,
//       }))
//     : [];

//   const selectAllowanceHandler = (e, index) => {
//     const selectedAllowance = allowance?.data.find((d) => d.code == e);
//     if (!selectedAllowance) return;
//     // setAdditionDetails((prev) =>
//     //   prev
//     //     .filter((_, i) => i === index)
//     //     .map((a) => ({
//     //       ...a,
//     //       code: selectedAllowance.code,
//     //       description: selectedAllowance.description,
//     //       isTaxPayable: selectedAllowance.isTaxPayable,
//     //       haveCpf: selectedAllowance.haveCpf,
//     //     }))
//     // );

//     setValue(`payrollDetail[${index}].adjCode`, selectedAllowance.code);

//     setValue(
//       `payrollDetail[${index}].adjDescription`,
//       selectedAllowance.description
//     );
//     setValue(
//       `payrollDetail[${index}].isTaxPayable`,
//       selectedAllowance.isTaxPayable
//     );
//     setValue(`payrollDetail[${index}].haveCPF`, selectedAllowance.haveCpf);
//   };

//   const selectDeductionHandler = (e, index) => {
//     const selecteddeduction = deduction?.data.find((d) => d.code == e);
//     if (!selecteddeduction) return;
//     // setDeductionDetails((prev) =>
//     //   prev
//     //     .filter((_, i) => i === index)
//     //     .map((a) => ({
//     //       ...a,
//     //       code: selecteddeduction.code,
//     //       description: selecteddeduction.description,
//     //       isTaxPayable: selecteddeduction.isTaxPayable,
//     //       haveCpf: selecteddeduction.haveCpf,
//     //     }))
//     // );
//     console.log("selecteddeduction", selecteddeduction);
//     console.log("index", index);

//     setValue(`payrollDetail[${index}].adjCode`, selecteddeduction.code);
//     setValue(
//       `payrollDetail[${index}].adjDescription`,
//       selecteddeduction.description
//     );
//     setValue(
//       `payrollDetail[${index}].isTaxPayable`,
//       selecteddeduction.isTaxPayable
//     );
//     setValue(`payrollDetail[${index}].haveCPF`, selecteddeduction.haveCpf);
//   };

//   return (
//     <div className="row">
//       {/* Additions */}
//       <div className="col-md-6 col-lg-6 col-sm-12">
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             marginBottom: 16,
//           }}
//         >
//           <h6>Additions</h6>
//           <button
//             type="button"
//             className="btn btn-secondary btn-sm"
//             onClick={() => handleAdd("addition")}
//           >
//             <PlusCircle className="me-2" /> Add Allowance
//           </button>
//         </div>
//         {isAllowanceLoading && <p>Loading...</p>}
//         {renderFields(1)}
//       </div>

//       {/* Deductions */}
//       <div className="col-md-6 col-lg-6 col-sm-12">
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             marginBottom: 16,
//           }}
//         >
//           <h6>Deductions</h6>
//           <button
//             type="button"
//             className="btn btn-secondary btn-sm"
//             onClick={() => handleAdd("deduction")}
//           >
//             <PlusCircle className="me-2" /> Add Deduction
//           </button>
//         </div>
//         {isDeductionLoading && <p>Loading...</p>}
//         {renderFields(0)}
//       </div>
//     </div>
//   );
// };

// export default PayrollAdditionDeductionForm;
